// What the build-spec lesson (V2401 / V3401) hands the student at 100%.
//
// It is their branded Starter App Template — the same app they watched come alive
// in Module 1 — as a PROJECT FOLDER, with the build spec they just finished written
// into its CLAUDE.md.
//
// WHY A FOLDER AND NOT A FILE
// It used to be one `index.html` with the spec in an HTML comment at the top, because
// a single file had nowhere else to put it. That worked for the day-one win and ran
// out of room immediately after: there was no place for a data layer, no place for
// Firebase, and no place for a project brief. The folder has all three — see
// starterTemplate/projectTemplate.js for what is in it and why.
//
// WHY THE SPEC MOVED TO CLAUDE.md
// Same reason it was in the file at all: the next thing this student does is open
// the project with Claude Code, and a spec Claude never reads is a spec that does
// nothing. An HTML comment was the only carrier a one-file download had. `CLAUDE.md`
// in the project root is the carrier a folder has, and Claude Code reads it every
// session without being asked — which is also the first time the STUDENT can read
// their own spec without viewing source.

import { buildProjectFiles } from "../../starterTemplate/projectTemplate.js";
import { buildProjectZip, slugify } from "../../starterTemplate/zip.js";

/**
 * Build the downloadable project.
 *
 * @param {object}      args
 * @param {object|null} args.project     Their `users_projects` record (brand + idea)
 * @param {object|null} args.spec        The finished build spec, or null to ship the app alone
 * @param {object}      args.labels      From buildStarterAppLabels(t)
 * @param {object}      args.specLabels  Localized spec headings (buildSpec.file.*)
 * @param {string}      args.locale      "es" or "en"
 * @returns {{ bytes: Uint8Array, folder: string, filename: string }}
 */
export const buildSpecDownloadZip = ({ project, spec, labels, specLabels, locale }) => {
    const files = buildProjectFiles({ project, spec, labels, specLabels, locale });

    // The folder inside the archive and the archive itself share one name, so the
    // student sees the same word twice and does not have to work out which is which.
    const folder = slugify(project?.appName);

    return {
        bytes: buildProjectZip(files, folder),
        folder,
        filename: `${folder}.zip`,
    };
};

export default buildSpecDownloadZip;
